(function () {
  class YoutubeVideo {
    constructor(elem, size, vars, autoplay) {
      this.playerVars = vars;
      this.id = elem.dataset.youtubeVideo;
      this.container = elem.closest('[data-youtube-container]');
      this.elem = elem;
      this.autoplay = !!(autoplay);
      this.size = size;

      this._events = {
        'ready': [
          () => this.container && this.container.classList.add('youtube-ready'),
        ],
        'play': [
          () => {
          this._playing = true;
          if (this.container) {
          setTimeout(() => {
          this.container.classList.add('youtube-playing');
          this.container.classList.add('youtube-started');
          }, 400)
          }
          },
        ],
        'pause': [
          () => {
          this._playing = false;
          if (this.container) {
          this.container.classList.remove('youtube-playing');
          }
          },
        ],
        'end': [
          () => {
          this._playing = false;
          if (this.container) {
          this.container.classList.remove('youtube-playing');
          this.container.classList.remove('youtube-started');
          }
          },
        ],
        'change': []
      };
      if (!this.YTavailable) this._implementYT();
    }

    get YTavailable () {
      return !!(window.YT && window.YT.Player);
    }

    get params () {
      return {
        videoId: this.id,
        width: this.size.width,
        height: this.size.height,
        playerVars: this.playerVars,
        events: {
          'onReady': e => this._onReady(e),
          'onStateChange': e => this._onStateChange(e),
          'onError': e => this._onError(e)
        }
      };
    }

    _implementYT() {
      var tag = document.createElement('script');

      tag.src = "https://www.youtube.com/iframe_api";
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    implementVideo() {
      if (this.YTavailable) {
        console.log('[HC] embeding video');
        this.player = new window.YT.Player(this.elem, this.params);
        this.elem.classList.add('hc-yt-implemented');
      } else {
        setTimeout(() => this.implementVideo(), 300);
      }
    }

    _onReady(event) {
      console.log('[HC] embeding video: ✔');
      // A workaround
      this._notReadyYet = true;
      event.target.mute();
      event.target.playVideo();
      setTimeout(e => {
        event.target.pauseVideo();
        event.target.seekTo(1);
        if (!this.autoplay) event.target.unMute();
        this._notReadyYet = false;
        if (this.autoplay) this.play();
      }, 3000);
      this.ready = true;
      this._callEvent('ready');
    }

    _onStateChange(e) {
      const data = e.data;
      const map = new Map([
        [window.YT.PlayerState.PLAYING, 'play'],
        [window.YT.PlayerState.PAUSED, 'pause'],
        [window.YT.PlayerState.ENDED, 'end']
      ]);
      console.log('[HC]', map);
      const event = map.get(data);
      console.log('[HC] stateChange : ', data, '-->', event);
      if (!this._notReadyYet && event) this._callEvent(event);
    }

    _onError(e) {
      console.error(e);
    }

    play() {
      this.player.getIframe().setAttribute('tabindex', '-1');
      console.log(this.player);
      this.player.playVideo();

    }
    pause() {
      this.player.pauseVideo();
    }

    toggle() {
      this._playing ? this.pause() : this.play();
    }

    addEventListener(event, fn) {
      const event_queue = this._events[event];
      if (!event_queue) return false;
      if (!typeof fn == "function") return false;
      event_queue.push(fn);
      return true;
    }
    _callEvent(event) {
      const event_queue = this._events[event];
      if (!event_queue) return false;
      for (const eventListener of event_queue) eventListener();
    }
  }
  
  const videos = new Map();
  
  function registerVideoId(video) {
    const genId = () => Math.round(Math.random() * 1000000000);
    const id = genId() + '';
    if (videos.has(id)) return registerVideoId(video);
    videos.set(id, video);
    video.container.dataset.videoId = id;
  }
  
  const loadElement = (el) => {
    const frameEl = document.createElement('DIV');
    frameEl.dataset.youtubeVideo = el.dataset.youtubeVideo;
    el.setAttribute('data-youtube-container', '');
    el.removeAttribute('data-youtube-video');
    if (el.dataset.aspectRatio) {
      const aspectRationContainer = document.createElement('DIV');
      aspectRationContainer.classList.add('hc-aspect-ratio-container');
      aspectRationContainer.append(frameEl);
      el.append(aspectRationContainer);
    } else {
      el.append(frameEl);
      el.style.setProperty('--html-width', el.dataset.width + 'px');
      el.style.setProperty('--html-height', el.dataset.height + 'px');
    } 
    el.style.position = 'relative';
    let asp = null;
    let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if(vw < 768) {
      if (el.dataset.aspectRatioMobile) {
        let [n,d] = el.dataset.aspectRatioMobile.split('/');
        n = parseInt(n);
        d = parseInt(d);
        if (!isNaN(n) && !isNaN(d)) {
          asp = n / d;
        }
        el.style.setProperty('--aspect-ratio', 1 / asp * 100 + '%');
      }
    } else {
      if (el.dataset.aspectRatio) {
        let [n,d] = el.dataset.aspectRatio.split('/');
        n = parseInt(n);
        d = parseInt(d);
        if (!isNaN(n) && !isNaN(d)) {
          asp = n / d;
        }
        el.style.setProperty('--aspect-ratio', 1 / asp * 100 + '%');
      }
    }
    const vWidth = el.dataset.width || '850';
    const vHeight = el.dataset.height || (asp && vWidth/asp) || '480';
    const video = new YoutubeVideo(frameEl, {
      width: vWidth,
      height: vHeight
    }, {
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      autohide: 0,
      controls: 1,
      branding: 0,
      showinfo: 0,
      rel: 0,
      fs: 0,
      autoplay: 1,
      mute: 1,
      wmode: 'opaque'
    }, 
      typeof el.dataset.autoplay !== 'undefined'
    );

    const img = document.createElement('IMG');

    img.src = (el.dataset.thumbnail && !el.dataset.thumbnail.includes('no-image') ? el.dataset.thumbnail : null) || `https://img.youtube.com/vi/${video.id}/hqdefault.jpg`;
    img.style.width = '100%';
    img.style.height = '100%';
    img.style.objectFit = 'cover';
    img.style.position = 'absolute';
    img.classList.add('hc-youtube-thumbnail');
    video.container.addEventListener('click', e => {
      if (!video._playing || typeof el.dataset.noControlls !== 'undefined') {
        video.toggle();
      }
    });
    video.container.append(img);
    video.implementVideo();
    
    registerVideoId(video);
    
    return video;
  }
  
  
  
  window.hcyt = {
    renderVideoAll: () => { for (const el of document.querySelectorAll(`[data-youtube-video]`)) if (el.tagName !== 'IFRAME') loadElement(el) },
    getVideo: el => videos.get(el.dataset.videoId),
    renderVideo: el => loadElement(el)
  }
})();

window.addEventListener('DOMContentLoaded', window.hcyt.renderVideoAll);
document.addEventListener('shopify:section:load', window.hcyt.renderVideoAll);